import { render, staticRenderFns } from "./TopInvestorsChart.vue?vue&type=template&id=39637532&"
import script from "./TopInvestorsChart.vue?vue&type=script&lang=js&"
export * from "./TopInvestorsChart.vue?vue&type=script&lang=js&"
import style0 from "./TopInvestorsChart.vue?vue&type=style&index=0&id=39637532&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports